import { Plus } from "lucide-react";
import { useCrud } from "./crud/useCrud";
import CrudForm from "./crud/CrudForm";
import CrudTableView from "./crud/CrudTableView";

/**
 * Generic CRUD table:
 *   - resource: url path segment
 *   - title / subtitle
 *   - columns: [{key, label, render?, align?, values?}]
 *   - fields: [{key, label, type, options?, required?, validate?, onChange?}]  (for form)
 *   - defaults: initial form · listParams: list query params
 *   - toolbar?: (items) => node — başlığın altında ek filtre/araçlar · filterFn?: (item) => bool — istemci tarafı süzme
 *   - readOnly?: Yeni / Düzenle / Sil gizlenir (yetkisiz kullanıcı yalnız görür)
 */
export default function CrudTable({ resource, title, subtitle, columns, fields, defaults, listParams, testidPrefix, toolbar, filterFn, readOnly = false }) {
  const crud = useCrud({ resource, fields, defaults, listParams });
  const items = filterFn ? crud.items.filter(filterFn) : crud.items;
  return (
    <div className="space-y-6" data-testid={`page-${testidPrefix}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="space-y-2">
          {title && <h1 className="text-3xl font-bold tracking-tight">{title}</h1>}
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
          {toolbar && <div data-testid={`${testidPrefix}-toolbar`}>{toolbar(crud.items)}</div>}
        </div>
        {!crud.editing && !readOnly && (
          <button onClick={crud.startNew} data-testid={`${testidPrefix}-add`}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800">
            <Plus className="w-4 h-4" /> Yeni
          </button>
        )}
      </div>

      {crud.editing === "new" && <CrudForm fields={fields} crud={crud} testidPrefix={testidPrefix} />}

      <CrudTableView items={items} columns={columns} userLabels={crud.userLabels} onEdit={(it) => (crud.editing === it.id ? crud.cancel() : crud.startEdit(it))} onRemove={crud.remove} testidPrefix={testidPrefix} readOnly={readOnly}
        editingId={crud.editing !== "new" ? crud.editing : null} editForm={crud.editing && crud.editing !== "new" ? <CrudForm fields={fields} crud={crud} testidPrefix={testidPrefix} inline /> : null} />
    </div>
  );
}
